module.exports = __webpack_public_path__ + "static/media/left-arrow.2ce13c06.svg";